'use strict';
const mmWidgets = require('./mm-widgets'),
	addPx = require('@mindmup/mapjs-core/src/util/px');
mmWidgets.fn.tableCellInPlaceEditorWidget = function () {
	const ENTER = 13, ESC = 27;
	return mmWidgets.each(this, function () {
		const element = this;
		element.on('click', function () {
			const previousText = element.text(),
				setContent = function (value) {
					element.empty().text(value);
					element.trigger('change');
				},
				input = mmWidgets('<input width="100%">'),
				clientRect = element.domElements[0].getBoundingClientRect(),
				oldWidth = Math.max(clientRect.width - 60, 50);
			if (element.find('input').length > 0) {
				return;
			}
			element.empty();
			input.appendTo(element)
				.val(previousText)
				.on('blur', function () {
					setContent(input.val());
				})
				.on('keydown', function (e) {
					if (e.which === ESC) {
						setContent(previousText);
						e.preventDefault();
						e.stopPropagation();
					}
					if (e.which === ENTER) {
						setContent(input.val());
						e.preventDefault();
						e.stopPropagation();
					}
				})
				.css({
					width: addPx(oldWidth),
					boxSizing: 'border-box'
				})
				.on('click', function (e) {
					e.stopPropagation();
					e.preventDefault();
				})
				.focus();
		});
		element.css('cursor', 'pointer');
	});
};
